export default __webpack_public_path__ + "static/media/faq1.355b7c28.jpg";